import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../../services/reports-service';
import { Report } from '../../models/report';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { FileVm } from '../../../../shared/Models/fileVm';
import { uploadService } from '../../../../shared/uploadService';
import { switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-report',
  templateUrl: './add-report.component.html',
  styleUrls: ['./add-report.component.scss'],
})
export class AddReportComponent implements OnInit {
  model = {} as Report;
  attachements = new FormData();
  isEdit = false;
  constructor(
    private route : Router,
    private diagRef: NbDialogRef<AddReportComponent>,
    private service: ReportsService,
    private uploadService: uploadService,
    private toast: NbToastrService
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
    if(this.isEdit){
      this.uploadService.updateFiles({ files:[],previousAttachments: this.model.attachements});
    }

    if (!this.isEdit) {
      this.model.descriptionAR = '';
      this.model.descriptionEN = '';
      this.uploadService.updateFiles({ files:[],previousAttachments:[]});
    }
  }

  save() {
    // let fileInput = document.getElementById('attachements') as any;

    this.uploadService.uploadMultipleFiles().pipe(
      switchMap((res) => {
        this.model.attachements = res;
        return this.isEdit ? this.service.put(this.model.id, this.model) :this.service.post(this.model) ;
      })
    ).subscribe({
      next: (res) => {
        this.diagRef.close('true');
        this.isEdit ? this.toast.show('تم التعديل بنجاح', '', { status: 'success', duration: 3000 }) : this.toast.show('تم إضافة  تقرير جديد بنجاح', '', { status: 'success', duration: 3000 });
      },
      error: (err) => {
        this.diagRef.close('true');
        this.isEdit ? this.toast.danger('خطأ في التعديل', '', { status: 'success', duration: 3000 }) : this.toast.danger('خطأ في الحفظ', '', { status: 'success', duration: 3000 });
      }
    })

  //   let hasAttachments = false;
  // this.attachements.forEach(() => {
  //   hasAttachments = true;
  // });


  //   if (hasAttachments) {
  //     this.service.uploadMultipleFiles(this.attachements).subscribe((res) => {
  //       this.model.attachements = [];
  //       res.forEach((element) => {
  //         this.model.attachements.push({
  //           fileName: element,
  //         } as FileVm);
  //       });

  //       this.saveReport();
  //     });
  //   } else {
  //     this.saveReport();
  //   }
  }

  saveReport() {
    this.service.post(this.model).subscribe((res) => {
      this.diagRef.close('true');
      this.toast.show('تم إضافة  تقرير جديد بنجاح', '', { status: 'success', duration: 3000 });
    });
  }

  // update(){
  //   this.service.put(this.model.id, this.model).subscribe((res) => {
  //     this.diagRef.close('true');
  //     this.toast.show('تم تعديل التقرير بنجاح', '', { status: 'success', duration: 3000 });
  //   });
  // }

  close() {
    this.diagRef.close();
  }

  isFormValid() {
    return this.model.nameAR;
  }

  uploadFile(files: any) {
    for (let file of files) {
      this.attachements.append(file.name, file);
    }
  }
}
